import * as React from 'react';
var defaults = {
    navigate: function (data) { }
};
var context = React.createContext(defaults);
export var NavigationProvider = context.Provider;
export var useNavigation = function () { return React.useContext(context); };
//# sourceMappingURL=navigation-context.js.map